import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = '';
const API = `${BACKEND_URL}/api`;

export const useGateway = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkStatus = async () => {
    try {
      const response = await axios.get(`${API}/gateway/status`);
      setIsConnected(response.data.connected);
      setStatus(response.data.status);
    } catch (error) {
      console.error('Error checking gateway status:', error);
      setIsConnected(false);
    } finally {
      setLoading(false);
    }
  };

  const reconnect = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${API}/gateway/reconnect`);
      setIsConnected(response.data.success);
      return response.data.success;
    } catch (error) {
      console.error('Error reconnecting to gateway:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatus();
    const interval = setInterval(checkStatus, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return {
    isConnected,
    status,
    loading,
    reconnect,
    checkStatus
  };
};
